/**
 * Branch bazli modul gorunurlugu — environment'dan bagimsiz.
 *
 * Dev branch:  MASTER_MERGE_FEATURE_FLAGS = MASTER_MERGE_FEATURE_FLAGS_DEV
 * Master branch: MASTER_MERGE_FEATURE_FLAGS = MASTER_MERGE_FEATURE_FLAGS_PROD
 *
 * Dev→master merge sonrasi asagidaki satiri PROD'a cek (veya conflict cozerken PROD sec).
 */
import { Routes } from '@angular/router';

export interface MasterMergeFeatureFlags {
  accounting: boolean;
  accountingRoutingLayerMethod: boolean;
  dashboardTask: boolean;
  taskManagement: boolean;
  projectManagement: boolean;
  /** Hesaplama / routing-layer kartlarında görev ikonu */
  calculationCardTaskIndicator: boolean;
  integrations: boolean;
  emissiondataPrevyears: boolean;
}

/** Dev branch sablonu — tum moduller acik */
export const MASTER_MERGE_FEATURE_FLAGS_DEV: MasterMergeFeatureFlags = {
  accounting: true,
  accountingRoutingLayerMethod: true,
  dashboardTask: true,
  taskManagement: true,
  projectManagement: true,
  calculationCardTaskIndicator: true,
  integrations: true,
  emissiondataPrevyears: true,
};

/** Master branch sablonu — onaylanan kapali moduller */
export const MASTER_MERGE_FEATURE_FLAGS_PROD: MasterMergeFeatureFlags = {
  accounting: true,
  accountingRoutingLayerMethod: true,
  dashboardTask: true,
  taskManagement: true,
  projectManagement: true,
  calculationCardTaskIndicator: true,
  integrations: true,
  emissiondataPrevyears: true,
};

/** Aktif branch ayari — master'dayken PROD, dev'deyken DEV */
export const MASTER_MERGE_FEATURE_FLAGS: MasterMergeFeatureFlags =
  MASTER_MERGE_FEATURE_FLAGS_PROD;

export function isMasterMergeFeatureEnabled(
  flags: MasterMergeFeatureFlags | undefined,
  key: keyof MasterMergeFeatureFlags,
): boolean {
  if (!flags) {
    return true;
  }

  return flags[key] !== false;
}

export function isActiveMasterMergeFeature(
  key: keyof MasterMergeFeatureFlags,
): boolean {
  return isMasterMergeFeatureEnabled(MASTER_MERGE_FEATURE_FLAGS, key);
}

/** Kart görev ikonu: projectManagement + calculationCardTaskIndicator birlikte açık olmalı */
export function isCalculationCardTaskIndicatorEnabled(): boolean {
  return (
    isActiveMasterMergeFeature('projectManagement') &&
    isActiveMasterMergeFeature('calculationCardTaskIndicator')
  );
}

export const SIDEBAR_MENU_FEATURE_BY_ID: Partial<
  Record<string, keyof MasterMergeFeatureFlags>
> = {
  'dashboard-task': 'dashboardTask',
  accounting: 'accounting',
  integrations: 'integrations',
};

export const PAGE_ROUTE_FEATURE_BY_PATH: Partial<
  Record<string, keyof MasterMergeFeatureFlags>
> = {
  'dashboard-task': 'dashboardTask',
  'task-management': 'taskManagement',
  'project-management': 'projectManagement',
  accounting: 'accounting',
  'emissiondata-prevyears': 'emissiondataPrevyears',
  'integration-management': 'integrations',
};

export function filterSidebarMenuItems<T extends { id?: string }>(
  items: T[],
): T[] {
  return items.filter((item) => {
    const featureKey = item.id
      ? SIDEBAR_MENU_FEATURE_BY_ID[item.id]
      : undefined;
    if (!featureKey) {
      return true;
    }
    return isActiveMasterMergeFeature(featureKey);
  });
}

export function filterRoutesByMasterMergeFeatures(routes: Routes): Routes {
  return routes.filter((route) => {
    if (!route.path) {
      return true;
    }

    const featureKey = PAGE_ROUTE_FEATURE_BY_PATH[route.path];
    if (!featureKey) {
      return true;
    }

    return isActiveMasterMergeFeature(featureKey);
  });
}
